import type { Language } from '@vmc/shared';

const numberFmt = new Intl.NumberFormat('en-IN');
const dateTimeFmt = new Intl.DateTimeFormat('en-IN', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});
const dateFmt = new Intl.DateTimeFormat('en-IN', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});
const timeFmt = new Intl.DateTimeFormat('en-IN', { hour: '2-digit', minute: '2-digit' });
const relFmt = new Intl.RelativeTimeFormat('en', { numeric: 'auto', style: 'short' });

export const fmtNumber = (n: number | null | undefined): string =>
  n == null ? '—' : numberFmt.format(n);

export const fmtDateTime = (iso: string | null | undefined): string =>
  iso ? dateTimeFmt.format(new Date(iso)) : '—';
export const fmtDate = (iso: string | null | undefined): string =>
  iso ? dateFmt.format(new Date(iso)) : '—';
export const fmtTime = (iso: string | null | undefined): string =>
  iso ? timeFmt.format(new Date(iso)) : '';

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['year', 365 * 86_400],
  ['month', 30 * 86_400],
  ['week', 7 * 86_400],
  ['day', 86_400],
  ['hour', 3_600],
  ['minute', 60],
];

/** "5 min. ago", "in 2 hr." — for lists where the exact time is in a tooltip. */
export function fmtRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  const seconds = (new Date(iso).getTime() - Date.now()) / 1000;
  for (const [unit, size] of UNITS) {
    if (Math.abs(seconds) >= size) return relFmt.format(Math.round(seconds / size), unit);
  }
  return 'just now';
}

/** 919812345670 → +91 98123 45670 (other countries: +<digits>). */
export function fmtPhone(waId: string): string {
  const m = /^91(\d{5})(\d{5})$/.exec(waId);
  return m ? `+91 ${m[1]} ${m[2]}` : `+${waId}`;
}

export const LANGUAGE_SHORT: Record<Language, string> = { EN: 'EN', GU: 'ગુ', HI: 'हि' };

/** BCP-47 tag for lang="" attributes, so screen readers and line-height rules pick the right script. */
export const LANGUAGE_TAG: Record<Language, string> = { EN: 'en', GU: 'gu', HI: 'hi' };

export const pluralize = (n: number, one: string, many = `${one}s`): string =>
  `${fmtNumber(n)} ${n === 1 ? one : many}`;

/** SCREAMING_CASE enum → "Screaming case". */
export const humanize = (v: string): string =>
  v.charAt(0) + v.slice(1).toLowerCase().replaceAll('_', ' ');
